import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import { borderColor, display, justifyContent } from 'styled-system';

import Alert from 'common/components/Alert';
import { SecondaryLinkButton } from 'common/components/Link';
import { MessageType } from 'common/enums/Alert';
import { useLocalization } from 'common/providers/LocaleProvider';

const UnstyledContinueShoppingButton = styled(SecondaryLinkButton)<any>`
  ${justifyContent};
  ${display};
  ${borderColor};
`;

const ContinueShoppingButton = (props: ComponentProps<typeof UnstyledContinueShoppingButton>) => (
  <UnstyledContinueShoppingButton
    justifyContent="center"
    display="flex"
    borderColor="sys.neutral.border.hover"
    mt="sp_16"
    {...props}
  />
);

export interface UnavailableArticleProps {
  categoryUrl?: string;
  warningMessage?: string;
}

const UnavailableArticle = ({ categoryUrl, warningMessage }: UnavailableArticleProps) => {
  const { t } = useLocalization();

  return (
    <>
      <Alert type={MessageType.Warning}>{warningMessage}</Alert>
      {categoryUrl ? (
        <ContinueShoppingButton data-testid="continue-shopping-button" href={categoryUrl}>
          {t('h24_continue_shopping')}
        </ContinueShoppingButton>
      ) : null}
    </>
  );
};

export default UnavailableArticle;
